import { render, staticRenderFns } from "./addRelationShip.vue?vue&type=template&id=5e0d39ca&scoped=true&"
import script from "./addRelationShip.vue?vue&type=script&lang=js&"
export * from "./addRelationShip.vue?vue&type=script&lang=js&"
import style0 from "./addRelationShip.vue?vue&type=style&index=0&id=5e0d39ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0d39ca",
  null
  
)

export default component.exports